module.exports = __webpack_public_path__ + "img/smart-building-2.bd986d14.png";